<template>
  <div>
    <template v-if="isLoading">
      <div class="row">
        <div class="col-md-12 skeleton-container">
          <div class="skeleton-progress progress mr-2" style="width: 330px; height: 20em;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
          </div>
          <div class="skeleton-progress progress mr-2" style="width: 330px; height: 20em;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="video-container">
        <div v-for="(brake_adjustment, key) in brake_adjustments" :key="key" class="video_wrap">
          <div v-for="(video, keyy) in brake_adjustment.videos" :key="keyy" class="video" @click="openVideo(video)">
            <img :src="video.thumbnail" class="thumbnail">
            <div class="title">
              <h3>{{ video.title }}</h3>
            </div>
          </div>
        </div>
      </div>
    </template>
    <modal :show="showModal" v-on:close="showModal = false; video_obj = Object;">
      <template slot="header"><h3>{{ video_obj.title }}</h3></template>
      <template>
        <iframe width="100%" height="534" :src="video_obj.url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </template>
    </modal>
  </div>
</template>
<script>
import { BrakeAdjustment } from '../../api/brake/brakeadjustment'
export default {
  data() {
    return {
      isLoading: false,
      showModal: false,
      video_obj: Object,
      brake_adjustments: []
    }
  },
  mounted() {
    if (localStorage.getItem('user') && localStorage.getItem('need_reset') !== '1') {
      this.getBrakeAdjustments()
    } else if (!localStorage.getItem('user')) {
      this.getBrakeAdjustments()
    }
  },
  methods: {
    getBrakeAdjustments() {
      this.isLoading = true
      BrakeAdjustment().then(response => {
            this.brake_adjustments = response.data.adjustments
            this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        });
    },
    openVideo(video) {
      this.showModal = true
      this.video_obj = video
    }
  }
}
</script>
<style lang="scss" scoped>
.skeleton-container {
  display: flex;
  flex-flow: row wrap;
  flex-direction: row;
  justify-content: center;
}
.video-container {
  display: flex;
  flex-flow: row wrap;
  flex-direction: row;
  justify-content: center;
}
.tab-title {
  text-transform: uppercase;
  color: #000;
  font-size: 14px;
  font-weight: bold;
}
.modal::v-deep {
  .modal-dialog {
    max-width: 920px;
  }
  .modal-content {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .modal-body {
    padding: 0;
  }
}
.video_wrap {
  display: flex;
  flex-flow: row wrap;
  flex-direction: row;
  justify-content: center;
  .video {
    margin: 10px 9px;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    background: #dad9d9;
    max-width: 330px;
    border: 1px solid #dad9d9;
    cursor: pointer;
    .thumbnail {
      width: 100%;
      height: 180px;
      display: block;
      border-radius: 0;
    }
    .title {
      padding: 10px;
      height: 50px;
      max-height: 50px;
      h3 {
        line-height: 14px;
        font-weight: bold;
        color: #000000;
        vertical-align: middle;
        text-align: center;
        padding: 0;
        text-transform: uppercase;
        margin: 0;
        font-size: 12px;
      }
    }
  }
}
</style>
